import angular from 'angular';

export default angular.module('app.services.ggcsv', [])
  .factory('ggCSV', function() {
    return class ggCSV {
      constructor() {
      }

      loadTableData(cols, rows) {
        let fields = _.chain(cols).filter({show: true}).map('field').value();
        let headers =_.chain(cols).filter({show: true}).map(col => col.title || col.field).value();

        this.data = [headers].concat(rows.map((row) => {
          return _.chain(row).pick(fields).values().value();
        }));
      }

      loadResponse(res) {
        this.data = this.csvData(res);
        this.filename = this.csvFilename(res);
      }

      loadCsvFilename(res){
        this.filename = this.csvFilename(res);
      }

      csvFilename(res) {
        if (res[0].csvFilename){
          return res[0].csvFilename;
        }

        if (this.overrideCsvFilename) {
          return `${this.overrideCsvFilename}.csv`;
        }

        let dates = [res[0].query.start_date, res[0].query.end_date].map((date) => date.split(' ')[0]);
        let postfix = res[0].csvPostfix || this.metric || 'all';

        return _.compact([
            this.basename,
            postfix.toUpperCase()
          ]).concat(dates).join('_') + '.csv';
      }

      csvData(res) {
        if (res[0].csvData)
          return res[0].csvData;

        let headers = [''].concat(res.map(r => r.data.overrides.tooltipName || r.data.overrides.name));
        let keys = _.map(res[0].data.rows, 'key');
        let values = res.map(r => _.map(r.data.rows, 'value'));
        let data = _.zip.apply(this, [keys].concat(values));
        return [headers].concat(data);
      }
    }
  });



/** WEBPACK FOOTER **
 ** ./src/services/ggCSV.js
 **/